// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPauseOutlinedSvg from "@fishx/icons-svg/es/asn/PPauseOutlined";
import FishxIcon from '../components/FishxIcon';

var PPauseOutlined = function PPauseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPauseOutlinedSvg
  }));
};

PPauseOutlined.displayName = 'PPauseOutlined';
export default React.forwardRef(PPauseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPauseOutlined.js
// module id = 3530
// module chunks = 0